const initState = {
    showPdf: true,
    content: 'fanieMaeDocName',
    source: ['Agate', 'Mercury', 'Onyx', 'Universe'], // Store selected guidelines for scenario search
    pageLoading: false,
}

export default function Common(state = initState, action) {
    const { type, data } = action

    switch (type) {
        case 'SHOW_PDF': {
            state.showPdf = data
            break
        }
        case 'CHANGE_PDF': {
            state.content = data
            break
        }
        case 'SCENARIO_SOURCE': {
            state.source = data
            break
        }
        case 'PAGE_LOADING': {
            state.pageLoading = data
            break
        }
        default:
            break
    }

    return state
}
